import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import classNames from "classnames";
import { Form } from 'react-final-form';
import { Field } from 'react-final-form-html5-validation';

import { MdPerson, MdVpnKey, MdSecurity } from "react-icons/md";
import {
  Container,
  Row,
  Col,
  Form as BSForm,
  Input,
  FormGroup,
  Label,
  FormFeedback
} from "reactstrap";

import { userInfo } from "../../store/actions/user";
import disableSubmit from "../../utils/disableSubmit"
import { ajax } from "../../services/ajax";
import Storage from "../../services/localStorage";
import { api } from "../../constants";

import Button from "../../components/Form/Button";
import CaptchaInput from "../../components/Form/CaptchaInput";

import styles from "./Login.module.scss";

const StyledInput = ({ input, label, id, meta: { error, touched }, ...rest }) => (
  <FormGroup>
    {label && <Label htmlFor={id}>{label}</Label>}
    <Input id={id} {...input} {...rest} invalid={error && touched} />
    {error && touched && <FormFeedback>{error}</FormFeedback>}
  </FormGroup>
)


const Login = props => {
  const [captchaImg, setCaptchaImg] = useState();
  const [captchaLoading, setCaptchaLoading] = useState();
  useEffect(() => {
    if (!captchaImg) {
      getCaptcha();
    }
  })
  const handleSubmit = values => {
    return ajax.post(api.endpoints.login, {
      captchaAnswer: values.captcha,
      email: values.username,
      password: values.password,
      session_id: Storage.get('sessionId')
    })
      .then(response => {
        props.userInfo(response.data);
        Storage.remove('sessionId');
      })
      .catch(err => {
        getCaptcha();
      })
  }
  const getCaptcha = () => {
    setCaptchaLoading(true);
    setCaptchaImg('Loading');
    ajax.get(
      api.endpoints.captcha,
      { responseType: 'blob' }
    )
      .then(response => {
        const reader = new FileReader();
        reader.onload = () => {
          Storage.set('sessionId', response.headers.session_id);
          setCaptchaImg(reader.result);
          setCaptchaLoading(false);
        }
        reader.readAsDataURL(response.data);
      })
  }
  return (
    <Container className={classNames(styles.login, 'd-flex flex-column justify-content-center')}>
      <Row className="justify-content-center">
        <Col xs="4" sm="5" md="3" lg="2" className="text-center">
          <img src="/logo.svg" width="100" alt="Shuffle" className={styles.logo} />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs="12" sm="10" md="4">
          <Form
            onSubmit={handleSubmit}
            subscription={{ submitting: true, pristine: true, errors: true }}
            render={({ handleSubmit, submitting, pristine, errors }) => (
              <BSForm
                onSubmit={handleSubmit}
                className={classNames({ disabled: submitting })}
              >
                <Field
                  name="username"
                  id="username"
                  type="email"
                  dir="ltr"
                  autoFocus
                  required
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  patternMismatch="آدرس ایمیل معتبر نیست"
                  pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  label={<><MdPerson /> ایمیل</>}
                  component={StyledInput}
                  placeholder="مثلاً: yourname@shuffle.one"
                  className="rtl-placeholder text-left"
                />
                <Field
                  name="password"
                  id="password"
                  type="password"
                  dir="ltr"
                  required
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  label={<><MdVpnKey /> رمز</>}
                  component={StyledInput}
                  placeholder="رمز را وارد کنید"
                  className="rtl-placeholder text-left"
                />
                <Field
                  name="captcha"
                  id="captcha"
                  type="tel"
                  dir="ltr"
                  required
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  label={<><MdSecurity /> تشخیص ربات</>}
                  component={CaptchaInput}
                  placeholder="متن تصویر مقابل را وارد کنید"
                  className="rtl-placeholder text-left"
                  image={captchaImg}
                  loading={captchaLoading}
                  reload={getCaptcha}
                />
                <Button
                  block
                  disabled={disableSubmit({ submitting, pristine, errors })}
                  loading={submitting}
                >
                  ورود
                </Button>
              </BSForm>
            )}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default connect(
  state => (
    {
      user: state.user,
    }
  ),
  dispatch => bindActionCreators({
    userInfo
  }, dispatch)
)(Login)